module.exports = __webpack_public_path__ + "img/purple_heart.9f4503e2.png";